import { NOPING_GREEN } from '../constants';

export function ArcadeGrid() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div
        className='absolute inset-x-0 bottom-0 h-[50%] opacity-[0.04]'
        style={{
          backgroundImage: `linear-gradient(${NOPING_GREEN} 1px, transparent 1px), linear-gradient(90deg, ${NOPING_GREEN} 1px, transparent 1px)`,
          backgroundSize: '60px 60px',
          maskImage: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
          WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
        }}
      />
      <div
        className='absolute inset-0 opacity-[0.015]'
        style={{
          backgroundImage: `repeating-linear-gradient(-45deg, transparent, transparent 8px, ${NOPING_GREEN} 8px, ${NOPING_GREEN} 9px)`,
        }}
      />
      <div
        className='absolute inset-0 opacity-[0.03]'
        style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.03'/%3E%3C/svg%3E\")",
          backgroundRepeat: 'repeat',
        }}
      />
    </div>
  );
}
